import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../../core/services/session-storage/session-storage.service';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IntroducerFormIndividualService {

  private sessionStorageService = inject(SessionStorageService);
  constructor() { }

  async getIntroducerApplicationDetails(id:number) {

     const API_URL: string = environment.baseUrl + environment.apis.getIntroducerApplication;
    // console.log(" token: " + this.sessionStorageService.getCurrentUserAuthToken());
    // console.log(" id: " + this.sessionStorageService.getCurrentUserId());
    // var id = parseInt(this.sessionStorageService.getCurrentUserId());
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "id": id
      }

    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);

      });
  }

  async updateIntroducerApplicationDetails(payload: any) {
    const API_URL: string = environment.baseUrl + environment.apis.updateIntroducerApplicationDetails;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST', // change to 'PUT'/'PATCH' if your backend expects that instead
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: JSON.stringify(payload) // ✅ stringify the payload object, not payload.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse); // ✅ send back .data, matching your GET methods' JSON.parse() usage
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

}
